<template>
  <div class="pa-2">
    <h2 class="pa-1">Content</h2>
    <v-layout wrap>
      <v-flex v-permission:any="['past-question.editor', 'past-question.reader']" xs12 md4 lg3 class="pa-1">
        <v-card>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Past Year Question</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn
                small
                color="green"
                text
                outlined
                @click="$router.push('/pastquestions/update')"
            >Update</v-btn>
            <v-btn
                small
                text
                outlined
                color="red"
                @click="$router.push('/pastquestions/add')"
                v-permission="['past-question.editor']"
            >New</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex v-permission:any="['test-question.editor', 'test-question.reader']" xs12 md4 lg3 class="pa-1">
        <v-card>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Test Question</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn
                small
                color="green"
                text
                outlined
                @click="$router.push('/tests/questions')"
            >UPDATE</v-btn>
            <v-btn
                small
                color="red"
                text
                outlined
                @click="$router.push('/tests/questions/create')"
            >CREATE</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex v-permission:any="['practice.editor', 'practice.reader']" xs12 md4 lg3 class="pa-1">
        <v-card>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Practice Question</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn
                small
                color="green"
                text
                outlined
                @click="$router.push('/practice/questions')"
            >UPDATE</v-btn>
            <v-btn
                small
                color="red"
                text
                outlined
                @click="$router.push('/practice/questions/create')"
            >CREATE</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex v-permission:any="['docs.editor', 'docs.reader']" xs12 md4 lg3 class="pa-1">
        <v-card>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Docs</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn
                small
                color="green"
                text
                outlined
                @click="$router.push('/docs/all')"
            >Update</v-btn>
            <v-btn
                small
                text
                outlined
                color="red"
                @click="$router.push('/docs/new')"
                v-permission="['docs.editor']"
            >New</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex v-permission:any="['explanation.editor', 'explanation.reader']" xs12 md4 lg3 class="pa-1">
        <v-card>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Explanation</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn
                small
                color="green"
                text
                outlined
                to="/explanation"
            >View</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import PermissionComponent from "@/components/PermissionComponent";
export default {
  name: "welcome",
  components: {PermissionComponent}
};
</script>

<style scoped>
.centered {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo {
  max-width: 100%;
}

.link-btn {
  width: 150px;
}
</style>
